import CorporateAdminDashboardAnalytics from 'components/Corporates/CorporateAdminDashboardAnalytics';
import CorporateMatrixTiles from 'components/Corporates/CorporateMatrixTiles';

const CorporateAdminDashboard = ({ corporateId }) => {
  return (
    <div>
      <div>
        <CorporateMatrixTiles corporateId={corporateId} />
        <CorporateAdminDashboardAnalytics corporateId={corporateId} />
      </div>
    </div>
  );
};
export default CorporateAdminDashboard;
